const urlAdmin = process.env.REACT_APP_SERVER_URL_ADMIN
const zipType = 'application/zip'

export const TutorMocks: {[key: string]: any} = {
    [`${urlAdmin}/tutors/receipt/failer_check`]: {
        is_failer: false
    },
    [`${urlAdmin}/tutors/:id/penalties-bonuses`]: {
        items: [
            {
                id: 1,
                type: 'bonus',
                amount: '2 000',
                comment: 'Сообщение 1',
                created_at: '2025-11-09 23:38:10',
            },
            {
                id: 2,
                type: 'bonus',
                amount: '6 000',
                comment: 'Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2',
                created_at: '2025-11-09 23:38:10',
            },
            {
                id: 3,
                type: 'penalty',
                amount: '4 000',
                comment: 'Сообщение 3',
                created_at: '2025-04-11 10:04:52',
            },
            {
                id: 4,
                type: 'bonus',
                amount: '10 000',
                comment: 'Сообщение 4',
                created_at: '2025-04-11 10:04:52',
            },
        ],
        summary: {
            penalties: '132',
            bonuses: '20'
        }
    },
    [`${urlAdmin}/tutors/penalties-bonuses`]: {
        items: [
            {
                id: 1,
                type: 'bonus',
                amount: '2 000',
                comment: 'Сообщение 1',
                created_at: '2025-11-09 23:38:10',
            },
            {
                id: 2,
                type: 'bonus',
                amount: '6 000',
                comment: 'Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2 Сообщение 2',
                created_at: '2025-11-09 23:38:10',
            },
            {
                id: 3,
                type: 'penalty',
                amount: '4 000',
                comment: 'Сообщение 3',
                created_at: '2025-04-11 10:04:52',
            },
            {
                id: 4,
                type: 'bonus',
                amount: '10 000',
                comment: 'Сообщение 4',
                created_at: '2025-04-11 10:04:52',
            },
        ],
        summary: {
            penalties: '132',
            bonuses: '20'
        }
    },
    [`${urlAdmin}/tutors/:id/accruals`]: {
        accruals: [
            {
                id: 1,
                date: '2025-11-09 23:38:10',
                amount: '20 000',
                is_receipt: false,
            },
            {
                id: 22,
                date: '2025-10-14 12:40:00',
                amount: '28 000',
                is_receipt: false,
            },
            {
                id: 33,
                date: '2025-04-11 10:04:52',
                amount: '5 000',
                is_receipt: true,
            }
        ]
    },
    [`${urlAdmin}/tutors/:id/receipts_list`]: {
        items: [
            {
                id: '1',
                date: '2025-11-09 23:38:10',
                amount: '20 000',
                comment: 'какой-то коммент 1',
                has_receipt: true,
                receipt_uploaded_at: new Blob(['mock receipt 1'], {type: zipType}),
            },
            {
                id: '2',
                date: '2025-10-14 12:40:00',
                amount: '28 000',
                comment: 'какой-то коммент 2',
                has_receipt: true,
                receipt_uploaded_at: new Blob(['mock receipt 2'], {type: zipType}),
            },
            {
                id: '3',
                date: '2025-04-11 10:04:52',
                amount: '5 000',
                comment: 'какой-то коммент 3',
                has_receipt: false,
                receipt_uploaded_at: new Blob(),
            },
        ]
    },
    [`${urlAdmin}/tutors/archive`]: {
        tutors: [
            {
                id: 1,
                full_name: 'asdf',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: true,
                has_only_trial: false,
                has_newbie: true
            },
            {
                id: 2,
                full_name: 'MAX',
                tg: "http",
                created_at: '12.11.2020',
                has_balance_negative: true,
                has_only_trial: true,
                has_newbie: false
            },
            {
                id: 3,
                full_name: 'PAVEL',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: false,
                has_only_trial: false,
                has_newbie: false
            },
        ],
        tutors_count: 22
    },
    [`${urlAdmin}/tutors/filter`]: {
        tutors: [
            {
                id: 1,
                full_name: 'asdf',
                tg: "http",
                created_at: '02.04.2444',
                has_balance_negative: true,
                has_only_trial: false,
                has_newbie: true,
                is_failer: true,
            },
            {
                id: 2,
                full_name: 'MAX',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: true,
                has_only_trial: true,
                has_newbie: false,
                is_failer: true,
            },
            {
                id: 3,
                full_name: 'PAVEL',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: false,
                has_only_trial: false,
                has_newbie: false,
                is_failer: true,
            },
        ],
        tutors_count: 22
    },
    [`${urlAdmin}/tutors/salaries`]: {
        data: {
            items: [
                {
                    user_id: 1,
                    full_name: 'Нечепорк Максим Алексеевич',
                    tg_admin_name: 'admin_1',
                    salary: '42 000',
                    payment_type: 'card',
                    recipient_name: 'Нечепорк Максим Алексеевич',
                    card_number: '2200 7001 2345 6789',
                    phone_number: '+7 999 111-22-33',
                    bank_name: 'Т-Банк',
                    account_number: '40817810099910004312',
                    bik: '044525974',
                    inn: '7707083893',
                },
                {
                    user_id: 2,
                    full_name: 'Иванова Анна Сергеевна',
                    tg_admin_name: 'admin_2',
                    salary: '36 500',
                    payment_type: 'sbp',
                    recipient_name: 'Иванова Анна Сергеевна',
                    card_number: '2200 2002 9876 5432',
                    phone_number: '+7 999 222-33-44',
                    bank_name: 'Сбербанк',
                    account_number: '40817810538001234567',
                    bik: '044525225',
                    inn: '771234567890',
                },
                {
                    user_id: 3,
                    full_name: 'Петров Павел Игоревич',
                    tg_admin_name: 'admin_1',
                    salary: '28 750',
                    payment_type: 'bank_account',
                    recipient_name: 'Петров Павел Игоревич',
                    card_number: '2200 3003 1111 2222',
                    phone_number: '+7 999 333-44-55',
                    bank_name: 'Альфа-Банк',
                    account_number: '40817810900000012345',
                    bik: '044525593',
                    inn: '772345678901',
                },
            ],
            total_salary: '107 250',
        }
    },
    [`${urlAdmin}/tutors/:id`]: {
        tutor: {
                id: 2,
                full_name: 'MAX ff ff',
                tg: "http",
                phone: '89520941111',
                cost_per_hour: '12',
                created_at: '12.04.5555',
                email: 'jopa@mail.ru',
                work_tg_name: '',
                work_tg_ids: [],
                is_archive: false,
            },
    },
    [`${urlAdmin}/tutors/:id/finance`]: {
        data: {
                amount: '1000',
                hours_count: '4',
                wages: 3000,
            },
    },
    [`${urlAdmin}/tutors`]: {
        tutors: [
            {
                id: 1,
                full_name: 'asdf',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: true,
                has_only_trial: false,
                has_newbie: true,
                is_failer: true,
            },
            {
                id: 2,
                full_name: 'MAX',
                tg: "http",
                created_at: '12.11.2020',
                has_balance_negative: true,
                has_only_trial: true,
                has_newbie: false,
                is_failer: false,
            },
            {
                id: 3,
                full_name: 'PAVEL',
                tg: "http",
                created_at: '12.04.2042',
                has_balance_negative: false,
                has_only_trial: false,
                has_newbie: false,
                is_failer: true,
            },
        ],
        tutors_count: 22
    },
    [`${urlAdmin}/tutors/:id/lessons`]: {
        lessons: [
            {
                "id": 1,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич",
                "date": "2023-01-02",
                "duration_minutes": 90
            },
            {
                "id": 2,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
            {
                "id": 3,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
            {
                "id": 4,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
            {
                "id": 5,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
            {
                "id": 6,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
            {
                "id": 7,
                "student_id": 1,
                "user_id": 1,
                "student_full_name": "Нечепорк Максим Алексеевич 222",
                "date": "2023-01-02",
                "duration_minutes": 120
            },
        ],
        lessons_count: 54
    },
};
